__turbopack_context__.v({
  "details": "Header-module-scss-module__VHYFbq__details",
  "facts": "Header-module-scss-module__VHYFbq__facts",
  "grid": "Header-module-scss-module__VHYFbq__grid",
  "hero": "Header-module-scss-module__VHYFbq__hero",
  "heroContent": "Header-module-scss-module__VHYFbq__heroContent",
  "images": "Header-module-scss-module__VHYFbq__images",
  "subtitle": "Header-module-scss-module__VHYFbq__subtitle",
  "title": "Header-module-scss-module__VHYFbq__title",
});
